import React, { Component } from "react";
import './javascript.css';
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import { NavLink } from 'react-router-dom';
import JSDefault from './content/default/default';
import JSIntroduction from './content/introduction/introduction';
import HTML from './content/html/html';
import CSS from './content/css/css';
import FirstScript from './content/firstscript/firstscript';
import JSVariables from './content/variables/variables';
import JSFunctions from './content/functions/functions';
import JSObjects from './content/objects/objects';

export default class JavaScript extends Component {

    pageHeaders: any;
    pageContent: any;

    constructor(props: any) {
        super(props);
        this.pageHeaders = [
            "introduction",
            "HTML",
            "CSS",
            "first script",
            "variables",
            "functions",
            "objects"
        ];
        this.pageContent = [
            "/javascript/introduction",
            "/javascript/html",
            "/javascript/css",
            "/javascript/firstscript",
            "/javascript/variables",
            "/javascript/functions",
            "/javascript/objects"
        ];
    }

    public componentDidMount() {

    }

    public render() {

        return (
            <div id = "javascript">

                <BrowserRouter>
                    <div id="menu">

                        <div id="jsHeader">

                            <h2>Javascript</h2>

                            <div id="headerOptions">

                                <NavLink to="/javascript" exact><input type="button" className="jsOptions" value="Javascript"></input></NavLink><br />

                                {this.pageHeaders.map((value: any, index: any, array: any) => {

                                    return (<span key={index}><NavLink to={this.pageContent[index]} exact><input type="button" className="jsOptions" value={array[index]}></input></NavLink></span>);

                                })}

                            </div>

                        </div>

                        <div id="contents">

                            <Switch>

                                <Route path="/javascript" component={JSDefault} exact />
                                <Route path="/javascript/introduction" component={JSIntroduction} exact />
                                <Route path="/javascript/html" component={HTML} exact />
                                <Route path="/javascript/css" component={CSS} exact />
                                <Route path="/javascript/firstscript" component={FirstScript} exact />
                                <Route path="/javascript/variables" component={JSVariables} exact />
                                <Route path="/javascript/functions" component={JSFunctions} exact />
                                <Route path="/javascript/objects" component={JSObjects} exact />

                            </Switch>

                        </div>

                    </div>
                </BrowserRouter>

            </div>
        );

    }

}